import {iconUrl} from 'data/icon'
import {ensureStatuses} from '../type'

export const SCH = ensureStatuses({
	BIO_II: {
		id: 189,
		name: 'Bio II',
		icon: iconUrl(210505),
		duration: 30000,
	},
	BIOLYSIS: {
		id: 1895,
		name: 'Biolysis',
		icon: iconUrl(212812),
		duration: 30000,
	},

	CHAIN_STRATAGEM: {
		id: 1221,
		name: 'Chain Stratagem',
		icon: iconUrl(212809),
		duration: 20000,
	},

	BANEFUL_IMPACTION: {
		id: 3883,
		name: 'Baneful Impaction',
		icon: iconUrl(212819),
		duration: 15000,
	},

	GALVANIZE: {
		id: 297,
		name: 'Galvanize',
		icon: iconUrl(212801),
		duration: 30000,
	},

	CATALYZE: {
		id: 1918,
		name: 'Catalyze',
		icon: iconUrl(212814),
		duration: 30000,
	},

	RECITATION: {
		id: 1896,
		name: 'Recitation',
		icon: iconUrl(212813),
		duration: 15000,
	},

	DISSIPATION: {
		id: 791,
		name: 'Dissipation',
		icon: iconUrl(212805),
		duration: 30000,
	},

	EXCOGITATION: {
		id: 1220,
		name: 'Excogitation',
		icon: iconUrl(212808),
		duration: 45000,
	},

	SACRED_SOIL: {
		id: 1944,
		name: 'Sacred Soil',
		icon: iconUrl(212802),
		duration: 15000,
	},

	EMERGENCY_TACTICS: {
		id: 792,
		name: 'Emergency Tactics',
		icon: iconUrl(212806),
		duration: 45000,
	},

	PROTRACTION: {
		id: 2710,
		name: 'Protraction',
		icon: iconUrl(212815),
		duration: 10000,
	},

	DESPERATE_MEASURES: {
		id: 2711,
		name: 'Desperate Measures',
		icon: iconUrl(212816),
		duration: 20000,
	},

	EXPEDIENCE: {
		id: 2712,
		name: 'Expedience',
		icon: iconUrl(212817),
		duration: 10000,
	},

	IMPACT_IMMINENT: {
		id: 3882,
		name: 'Impact Imminent',
		icon: iconUrl(212818),
		duration: 30000,
	},

	SERAPHISM: {
		id: 3884,
		name: 'Seraphism',
		icon: iconUrl(212820),
		duration: 20000,
	},

	SERAPHISM_HOT: {
		id: 3885,
		name: 'Seraphism',
		icon: iconUrl(212823),
		duration: 20000,
	},

	// -----
	// PET
	// -----

	FEY_UNION: {
		id: 1223,
		name: 'Fey Union',
		icon: iconUrl(212811),
	},

	WHISPERING_DAWN: {
		id: 315,
		name: 'Whispering Dawn',
		icon: iconUrl(212826),
		duration: 21000,
	},

	ANGELS_WHISPER: {
		id: 1874,
		name: 'Angel\'s Whisper',
		icon: iconUrl(212846),
		duration: 21000,
	},

})
